import { Pagination } from "@material-ui/lab";
import React from "react";
import { Container, Row, Col, Button, Modal, InputGroup, Form, FormControl, ButtonGroup, Table, Spinner } from 'react-bootstrap';
import { ChainJobRequest, GetChainJobResponse } from "../../../data/chainJob/chainJob.shemas";
import { FaRegEdit } from "react-icons/fa";


type Props = {
    chainjobList: GetChainJobResponse[]
}

export default function ChainJobConfigTable(props: Props) {
    const { chainjobList } = props

    return (
        <Container>
            <Row className='mt-2'>
                <Col md={6}>
                    <Container>
                        <Form className="d-flex justify-content-end justify-content-md-start align-items-center text-nowrap" style={{ gap: '0 12px' }}>
                            <Form.Label style={{ margin: 0 }} htmlFor="inlineFormCustomSelectPref">
                                Show
                            </Form.Label>
                            <Form.Control
                                as="select"
                                className="my-1 mr-sm-2"
                                id="inlineFormCustomSelectPref"
                                custom
                                size="sm"
                                style={{ width: 'fit-content', margin: 0 }}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Form.Control>
                            <Form.Label style={{ margin: 0 }} htmlFor="inlineFormCustomSelectPref">
                                entries
                            </Form.Label>
                        </Form>
                    </Container>
                </Col>
                <Col md={6}>
                    <div className='d-flex justify-content-end my-2 my-lg-0'>
                        <Pagination
                            count={chainjobList.length}
                            shape="rounded"
                            defaultPage={1}
                            showFirstButton
                            showLastButton
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table className="table-bordered table-hover rounded custom-table-list table-responsive-lg" size="sm">
                        <thead className="rounded">
                            <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                                <th style={{ width: '5%' }} className='text-center'></th>
                                <th style={{ width: '8%' }}>Company Code</th>
                                <th style={{ width: '20%' }}>Chain Job ID</th>
                                <th style={{ width: '20%' }}>Chain Job Name</th>
                                <th style={{ width: '32%' }}>Job List</th>
                                <th style={{ width: '5%' }}>Is Active</th>
                                <th style={{ width: '10%' }}>Cron Trigger</th>
                            </tr>
                        </thead>
                        <tbody>
                            {chainjobList.map((value, index) => {
                                console.log(value.chainId);
                                return (<tr key={index} >
                                    <td className='text-center'>
                                        <Button variant="info" size="sm"><FaRegEdit /></Button>
                                    </td>
                                    <td className='text-center'>{value.companyCode}</td>
                                    <td className='text-center'>{value.chainId}</td>
                                    <td className='text-center'>{value.chainName}</td>
                                    <td className='text-overflow'>{value.legacyList}</td>
                                    <td className='text-center'>{value.isActive}</td>
                                    <td className='text-center'></td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container >
    )
}